import { InstagramOutlined,
    FacebookFilled} from '@ant-design/icons'
import facebookLogo from "./facebook.png";

const contents = {
    en:{
        header_share_btn: 'SHARE',
        header_share_icon1: <img src={facebookLogo} style={{height: '15px'}}
                                              onClick={() => {
                                                  window.open('https://www.facebook.com/sharer/sharer.php?u=https://cemoy.com/gallery')
                                              }}
        />,
        // <i className='iconfont icon-Facebook'
        //                         style={{ fontSize: '12px', width: '15px', transform: 'scale(.8)' }}
        //                         onClick={() => {this.openUrl('https://www.facebook.com/sharer/sharer.php?u=http://cemoy.com/gallery')}} alt=''></i>,
        header_share_icon2: <><InstagramOutlined style={{ fontSize: '6px' , display: 'none' }}
                                                 onClick = {() => {this.openUrl('https://www.instagram.com/cemoyofficial/')}}></InstagramOutlined>&nbsp;</>,
        header_music_name: 'SOUND CREDITE: EBA - LOFI IS',
        header_shop_btn: 'SHOP',
        header_shop_url: 'https://shop.cemoy.com.au/',
    },
    ch:{
        // header_share_btn: '分享',
        // header_share_icon1:  <i className='iconfont icon-Facebook'
        //                         style={{ fontSize: '12px', width: '15px', transform: 'scale(.8)', display: 'none' }}
        //                         onClick={() => {this.openUrl('https://www.facebook.com/sharer/sharer.php?u=http://54.252.255.15/doc/cemoy-sv/index.html')}} alt=''></i>,
        // header_share_icon2: <><InstagramOutlined style={{ fontSize: '6px' , display: 'none' }}
        //                                          onClick = {() => {this.openUrl('https://www.instagram.com/cemoyofficial/')}}></InstagramOutlined>&nbsp;</>,
        header_music_name: 'SOUND CREDITE: EBA - LOFI IS',
        header_shop_btn: '天猫旗舰店',
        header_shop_url: 'https://cemoy.tmall.com/',
    }
}

export function getContent(code, key){
    return contents[code][key]
}

// import { getContent } from './content.js'
// { getContent(language, 'xxxxxxxx') }
